//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextInput";
import { updateLoginLimitValidationForm } from "../../utils/validationSchemas";

const LoginLimit = (props: any) => {
  const { user } = props;
  const {
    register,
    formState: { errors },
    setError,
    handleSubmit,
  } = useForm<any>({
    resolver: yupResolver(updateLoginLimitValidationForm),
    defaultValues: async () => {
      return {
        allowed_desktop_login: user?.allowed_desktop_login,
        allowed_mobile_login: user?.allowed_mobile_login,
      };
    },
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["users"],
    navigateURL: "",
  });

  const handleUpdate = async (values: any, setError: any) => {
    const url = `${APIS.USER}${user?.id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <form
        onSubmit={handleSubmit((data: any) => handleUpdate(data, setError))}
        autoComplete="off"
      >
        <div className={tw`grid grid-cols-2 gap-x-4 px-4`}>
          <TextField
            label={"Desktop Device"}
            register={register("allowed_desktop_login")}
            errors={errors?.allowed_desktop_login}
          />
          <TextField
            label={"Mobile Device"}
            register={register("allowed_mobile_login")}
            errors={errors?.allowed_mobile_login}
          />
        </div>
        <div className={tw`flex justify-end w-full`}>
          <div className={tw`w-[100px] mr-4`}>
            <Button label={"Update"} />
          </div>
        </div>
      </form>
    </>
  );
};

export default LoginLimit;
